import React, { useEffect, useRef, useState } from "react";

export const FrameView = ({ src, title }) => {
  const ref = useRef(null);
  const [style, setStyle] = useState({ width: "100%", height: "100vh" });

  useEffect(() => {
    const fit = () => {
      const el = ref.current;
      if (!el) return;

      const content = el.parentElement;
      const cs = getComputedStyle(content);
      const pT = parseFloat(cs.paddingTop) || 0;
      const pR = parseFloat(cs.paddingRight) || 0;
      const pB = parseFloat(cs.paddingBottom) || 0;
      const pL = parseFloat(cs.paddingLeft) || 0;

      const cardTop = content.getBoundingClientRect().top;

      let outerBottom = 0;
      let node = content.parentElement;
      while (node && node !== document.body) {
        outerBottom += parseFloat(getComputedStyle(node).paddingBottom) || 0;
        node = node.parentElement;
      }

      const height = window.innerHeight - cardTop - outerBottom;

      setStyle({
        display: "block",
        border: "none",
        borderRadius: "8px",
        boxSizing: "border-box",
        margin: `-${pT}px -${pR}px -${pB}px -${pL}px`,
        width: `calc(100% + ${pL + pR}px)`,
        height: `${height}px`,
      });
    };

    fit();
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, []);

  return <iframe ref={ref} style={style} title={title} src={src} />;
};
